import {
	Table,
	TableHead,
	TableBody,
	TableRow,
	TableCell,
	Paper,
	TableContainer,
	TableFooter,
	LinearProgress,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import CustomPagination from "../../../../components/paginate";
import { useContext } from "react";
import { ContextRegister } from "../context-api";
import libFloat from "../../../../util/libFloat";
import { formatInTimeZone } from "date-fns-tz";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileAlt, faCog, faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import ModalMain from "../../../../components/modal";

const formatCellValue = (value, column, onClick) => {
	if (value === undefined || value === null) return "";
	const { format: formatType, clickable, map } = column;

	switch (formatType) {
		case "currency":
			return libFloat.strToCurrency(value);

		case "date":
			return formatInTimeZone(new Date(value), "UTC", "dd/MM/yyyy");

		case "badgePgto":
			return (
				<div
					className={`${value === "SIM" ? "badge_status bg_red" : "badge_status bg_green"} ${
						clickable ? "cursor-pointer" : ""
					}`}
					onClick={clickable ? onClick : null}
				>
					{value === "SIM" ? "Pendente" : "Pago"}
				</div>
			);
		case "badgeAtivo": {
			const isActive = value === true || value === "true" || value === 1 || value === "1";

			return (
				<div className={`badge_status ${isActive ? "bg_green" : "bg_red"}`}>{isActive ? "Sim" : "Não"}</div>
			);
		}
		case "badgeAtivoSoft": {
			const isActive = value === true || value === "true" || value === 1 || value === "1";

			return (
				<div className={`badge_status cursor-default ${isActive ? "bg_green_soft" : "bg_red_soft"}`}>
					{isActive ? "Sim" : "Não"}
				</div>
			);
		}
		case "badgeAdmin": {
			const isActive = value === "ATIVO";

			return <div className={`badge_status ${isActive ? "bg_green" : "bg_green"}`}>{value}</div>;
		}
		case "badgeStatus": {
			const isActive = value === "ATIVO";

			return (
				<div className={`badge_status cursor-default ${isActive ? "bg_green_soft" : "bg_red_soft"}`}>
					{isActive ? "Ativo" : "Inativo"}
				</div>
			);
		}case "image":
			return (
				<img
					src={value}
					alt="Imagem"
					style={{ width: 50, height: 50, borderRadius: "5px", objectFit: "cover" }}
					onError={(e) => (e.target.src = "/fallback-image.png")}
				/>
			);
		case "banner":
			return (
				<img
					src={value}
					alt="Imagem"
					style={{ width: 130, height: 50, borderRadius: "5px", objectFit: "cover" }}
					onError={(e) => (e.target.src = "/fallback-image.png")}
				/>
			);

		case "map":
			return map && map[value] ? map[value] : value;

		default:
			return value;
	}
};

const itemsPerPage = 15; // Quantidade de itens por página

function TableMain({ handleOpenModalRegister, FormAux }) {
	const {
		options,
		selectData,
		setSelectData,
		searchedData,
		nextFetch,
		page,
		setPage,
		totalPage,
		currentPage,
		loading,
	} = useContext(ContextRegister);

	const handleChangePage = (event, newPage) => {
		if (newPage > currentPage.current && totalPage === 0) {
			nextFetch(newPage);
		}
		setPage(newPage);
	};

	const handleClickEdit = (item) => {
		setSelectData(item);
		handleOpenModalRegister();
		// handleOpenModalRegister(item);
	};

	const handleConfig = (item) => {
		setSelectData(item);
		handleOpenModalAux();
	};

	const handleOpenModalAux = () => {
		const event = new CustomEvent(`${"aux"}`);
		window.dispatchEvent(event);
	};

	const startIndex = (page - 1) * itemsPerPage;
	const endIndex = startIndex + itemsPerPage;
	const slicedData = searchedData.slice(startIndex, endIndex);

	return (
		// <Paper>
		<>
			<TableContainer component={Paper}>
				<Table>
					<TableHead className="color-table">
						<TableRow>
							{options.tableColumns.map((column) => {
								const isAction = column.key === "actions" || column.key === "action_config";
								return (
									<TableCell
										key={column.key}
										align={column.align}
										sx={{
											...(column.width ? { width: column.width, minWidth: column.width } : {}),
											...(isAction ? {
												position: "sticky",
												right: 0,
												backgroundColor: "var(--texto-secondary)",
												zIndex: 10,
												textAlign: "center",
												boxShadow: "-2px 0 5px rgba(0,0,0,0.05)"
											} : {})
										}}
									>
										<span className="text-color-table">{column.label}</span>
									</TableCell>
								);
							})}
						</TableRow>
					</TableHead>
					<TableBody>
						{slicedData.map((item, key) => {
							const rowKey = key; //item.id_complementos_grupo; // Certifique-se de que esse valor é único

							return (
								<TableRow key={rowKey} className="zebra-row">
									{options.tableColumns.map((column) => {
										const cellKey = `${rowKey}-${column.key}`; // Garantir chave única
										const isAction = column.key === "actions" || column.key === "action_config";
										const isOdd = key % 2 === 0;
										const rowBgColor = isOdd ? "#f3f6fc" : "white";

										return (
											<TableCell
												key={cellKey}
												align={column.align}
												sx={{
													...(column.width ? { width: column.width, minWidth: column.width } : {}),
													...(isAction ? {
														position: "sticky",
														right: 0,
														backgroundColor: rowBgColor,
														zIndex: 2,
														boxShadow: "-2px 0 5px rgba(0,0,0,0.05)"
													} : {})
												}}
											>
												{column.key.startsWith("action") ? (
													column.key === "actions" ? (
														<div className="flex gap-1 justify-end">
															{options.onReport && (
																<button
																	className="btn btn-sm btn-outline-primary"
																	title="Gerar relatório da venda"
																	onClick={() => options.onReport(item)}
																>
																	<FontAwesomeIcon icon={faFileAlt} />
																</button>
															)}
															{options.onAlterarVenda && item.id_venda && (
																<button
																	className="btn btn-sm btn-outline-warning"
																	title="Alterar Venda"
																	onClick={() => options.onAlterarVenda(item)}
																>
																	<FontAwesomeIcon icon={faPenToSquare} />
																</button>
															)}
															<button
																className="btn btn-sm btn-outline-primary"
																onClick={() => handleClickEdit(item)}
															>
																<EditIcon />
															</button>
														</div>
													) : column.key === "action_config" ? (
														<button
															className="btn btn-sm btn-outline-primary flex items-center"
															onClick={() => handleConfig(item)}
														>
															<FontAwesomeIcon icon={faCog} size="lg" />
														</button>
													) : null
												) : (
													formatCellValue(
														item[column.key],
														column,
														() => handleClickEdit(item)
													) || ""
												)}
											</TableCell>
										);
									})}
								</TableRow>
							);
						})}
					</TableBody>
					{loading ? (
						<TableFooter>
							<TableRow>
								<TableCell colSpan={options.tableColumns.length}>
									<LinearProgress variant="indeterminate" />
								</TableCell>
							</TableRow>
						</TableFooter>
					) : (
						searchedData.length === 0 && (
							<TableBody>
								<TableRow>
									<TableCell colSpan={options.tableColumns.length} className="italic text-gray-400">
										Nenhum registro encontrado.
									</TableCell>
								</TableRow>
							</TableBody>
						)
					)}
				</Table>

				{searchedData?.length > 0 && (
					<CustomPagination
						count={Math.ceil(searchedData.length / itemsPerPage)}
						page={page}
						onChangePage={handleChangePage}
						totalRecord={searchedData.length}
						totalPage={totalPage}
					/>
				)}
			</TableContainer>
			{FormAux && (
				<ModalMain ident={"aux"}>
					<FormAux selectedData={selectData} />
				</ModalMain>
			)}
		</>
	);
}

export default TableMain;

/* {loading && (
				<div className="flex h-44">
					<Loading mensagem="Carregando dados dos produtos" />
				</div>
			)} */
